import { mapGetters } from 'vuex';
import jwt from 'jsonwebtoken';

// eslint-disable-next-line import/prefer-default-export
export const accesses = {
  computed: {
    ...mapGetters({
      idToken: 'authentication/idToken',
    }),
  },
  methods: {
    hasAccess(role) {
      const decoded = jwt.decode(this.idToken);
      const roles = decoded.roles || [];

      return roles ? roles.filter(userRole => userRole.name === role).length > 0 : false;
    },
    hasAtLeastOneAccess(roles) {
      return !!roles.find(role => this.hasAccess(role));
    },
  },
};
